import React from 'react';
import { Bar } from 'react-chartjs-2';
import 'chart.js/auto';

const RegionWiseChart = ({ chartData }) => {
    const data = {
        labels: chartData?.regionLabel,
        datasets: [
            {
                label: 'Target',
                data: chartData?.regionTarget,
                backgroundColor: '#91a5f9', // Cornflower Blue
                hoverBackgroundColor: '#91a5f9',
                hoverBorderColor: '#91a5f9',
                borderColor: '#91a5f9',
                borderWidth: 1,
                maxBarThickness: 40,
            },
            {
                label: 'Achievement',
                data: chartData?.regionAchieved,
                backgroundColor: '#ffceff', // Light Pink
                hoverBackgroundColor: '#ffceff',
                hoverBorderColor: '#ffceff',
                borderColor: '#ffceff',
                borderWidth: 1,
                maxBarThickness: 40,
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        datalabels: {
            display: false,
            color: '#fff',
        },
        categoryPercentage: 0.8,
        barPercentage: 0.9,
        plugins: {
            legend: {
                display: false,
            },
            datalabels: {
                display: false, // Ensure no data labels are shown inside the bars
            },
            // tooltip: {
            //     callbacks: {
            //         label: function (context) {
            //             let label = context.dataset.label || '';
            //             if (label) {
            //                 label += ': ';
            //             }
            //             label += new Intl.NumberFormat('en-IN', {
            //                 style: 'currency',
            //                 currency: 'INR',
            //                 minimumFractionDigits: 0,
            //             }).format(context.parsed.y);
            //             return label;
            //         },
            //     },
            // },
        },
        scales: {
            // y: {
            //     ticks: {
            //         callback: function (value) {
            //             return value / 100000 + 'Lac';
            //         },
            //     },
            // },
        },
    };

    return (
        <div className='overflow-auto'>
            <Bar data={data} height={412} options={options} />
        </div>
    );
};

export default RegionWiseChart;